import React, { useEffect } from 'react';
import { initFBPixel, trackPageView } from './utils/fbpixel';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { TruthSection } from './components/TruthSection';
import { FailedSolutions } from './components/FailedSolutions';
import { MechanismSection } from './components/MechanismSection';
import { ProductSection } from './components/ProductSection';
import { TimelineSection } from './components/TimelineSection';
import { AudienceSection } from './components/AudienceSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initFBPixel('1430498875475197');
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-slate-50 font-sans selection:bg-orange-500/30 selection:text-orange-900" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainSection data-id="element-3" />
        <TruthSection data-id="element-4" />
        <FailedSolutions data-id="element-5" />
        <MechanismSection data-id="element-6" />
        <ProductSection data-id="element-7" />
        <TimelineSection data-id="element-8" />
        <AudienceSection data-id="element-9" />
        <FAQSection data-id="element-10" />
        <OfferSection data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}